<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Edit Magazine</h1>
        </template>
        <div class="">
            <div class="mt-2">
                <label for="name" class="font-bold">Enter Name</label>
                <input
                    id="name"
                    v-model="magazine.name"
                    class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full"
                    name="name"
                    placeholder="Enter name"
                    type="text"
                />
                <p
                    class="text-destructive"
                    v-if="errors.name && errors.name.length > 0"
                >
                    {{ errors.name[0] }}
                </p>
            </div>
            <div class="mt-4">
                <label class="font-bold">Schedule</label>
                <div class="">
                    <div class="inline-block relative">
                        <select
                            v-model="magazine.hourByDay.day"
                            class="block appearance-none w-full bg-white border border-gray-dark border-b-2 cursor-pointer p-2 leading-tight rounded text-sm"
                        >
                            <option :value="null">Days</option>
                            <option
                                v-for="option in daysOfWeek"
                                :key="'day-of-week-' + option.dayOfWeek"
                                :value="option.dayOfWeek"
                            >
                                {{ option.label }}
                            </option>
                        </select>
                        <div
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'caret-down']"
                                class=""
                            ></font-awesome-icon>
                        </div>
                    </div>
                    <vue-timepicker
                        class="magazine-time-picker"
                        v-model="magazine.hourByDay.hour.raw"
                        format="hh:mma"
                        placeholder="hh:mm"
                    />
                </div>
                <p
                    class="text-destructive"
                    v-if="
                        errors['schedule.hour'] &&
                        errors['schedule.hour'].length > 0
                    "
                >
                    {{ errors["schedule.hour"][0] }}
                </p>
                <p
                    class="text-destructive"
                    v-if="
                        errors['schedule.day'] &&
                        errors['schedule.day'].length > 0
                    "
                >
                    {{ errors["schedule.day"][0] }}
                </p>
            </div>
        </div>
        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Creating..."
                @click.native="save"
            >
                Update
            </progressable-button>
            <button
                class="ml-2 py-2 px-4 rounded-md bg-primary-lightest"
                @click="close"
            >
                Cancel
            </button>
        </template>
    </modal-component>
</template>

<script>
export default {
    name: "edit-magazine",
    props: {
        magazineId: {
            required: true,
        },
    },
    data() {
        return {
            errors: {},
            loading: false,
            periodicity: [
                { value: "daily", label: "Daily" },
                { value: "weekly", label: "weekly" },
            ],
            magazine: {
                name: "",
                hourByDay: {
                    day: 1,
                    hour: Schedule.emptyHour(),
                },
                description: "",
            },
            daysOfWeek: [
                { dayOfWeek: 1, label: "Monday" },
                { dayOfWeek: 2, label: "Tuesday" },
                { dayOfWeek: 3, label: "Wednesday" },
                { dayOfWeek: 4, label: "Thursday" },
                { dayOfWeek: 5, label: "Friday" },
                { dayOfWeek: 6, label: "Saturday" },
                { dayOfWeek: 7, label: "Sunday" },
            ],
        };
    },
    methods: {
        makeSchedule() {
            return {
                day: this.magazine.hourByDay.day,
                hour: Schedule.makeHourFromRaw(this.magazine.hourByDay.hour),
            };
        },
        makeMagazine(magazine) {
            this.magazine.name = magazine.name;
            this.magazine.description = magazine.description;
            this.magazine.hourByDay = {
                hour: Schedule.makeRawHour(magazine.schedule.hour),
                day: magazine.schedule.day,
            };
        },
        getMagazine() {
            axios
                .get(`/api/magazines/${this.magazineId}`)
                .then((response) => this.makeMagazine(response.data.data));
        },
        save() {
            this.loading = true;
            axios
                .put(`/api/magazines/${this.magazineId}`, {
                    schedule: this.makeSchedule(),
                    name: this.magazine.name,
                    description: this.magazine.description,
                })
                .then((response) => {
                    Event.$emit("toast", {
                        text: "Magazine updated successfully.",
                    });
                    this.$emit("resolve");
                    this.$emit("close");
                })
                .catch((err) => {
                    if (err.response.status === 403 && err.response?.data?.message) {
                        Event.$emit('toast', { text: err.response.data?.message, type: 'danger' });
                    }
                    this.errors = err.response.data.errors;
                    this.loading = false;
                })
                .then(() => {
                    this.loading = false;
                });
        },
        close() {
            this.$emit("close");
        },
    },
    mounted() {
        this.getMagazine();
    },
};
</script>

<style scoped></style>
